





































import { Component } from 'vue-property-decorator';
import MixinPage from '@/plugins/podolib/services/helper/mixins/page';

import Page from '@/components/Page.vue';
import HomeWelcome from '@/components/home/HomeWelcome.vue';
import HomeInformations from '@/components/home/HomeInformations.vue';
import HomePatients from '@/components/home/HomePatients.vue';
import HomeStation from '@/components/home/HomeStation.vue';
import HomeRecentAcquisitions from '@/components/home/HomeRecentAcquisitions.vue';
import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';
import HomeBannerTrial from '@/components/home/HomeBannerTrial.vue';
import HomeWalkingDemoTrial from '@/components/home/HomeWalkingDemoTrial.vue';
import HomeRunningDemoTrial from '@/components/home/HomeRunningDemoTrial.vue';
import HomeRightSidebar from '@/components/home/HomeRightSidebar.vue';
import HomeConfigureKit from '@/components/equipments/EquipmentsConfigureKit.vue';
import HomeWelcomeDialog from '@/components/home/HomeWelcomeDialog.vue';
import HomeWidgets from '@/components/home/HomeWidgets.vue';
import HomeGetStarted from '@/components/home/HomeGetStarted.vue';
import HomeModules from '@/components/home/HomeModules.vue';
import HomeNewAcquisition from '@/components/home/HomeNewAcquisition.vue';

interface Home extends MixinPage {
  showUpdateInformations: boolean;
  totalPatient: number | null;
  setTotalPatient(): void;
}

@Component<Home>({
  components: {
    HomeNewAcquisition,
    HomeModules,
    HomeGetStarted,
    HomeWidgets,
    Page,
    HomeWelcomeDialog,
    HomeConfigureKit,
    HomeRightSidebar,
    HomeRunningDemoTrial,
    HomeWalkingDemoTrial,
    HomeBannerTrial,
    ElementBgIcon,
    HomeRecentAcquisitions,
    HomeStation,
    HomePatients,
    HomeInformations,
    HomeWelcome,
  },
  metaInfo() {
    return {
      title: this.$options.filters!.capitalize(this.$t('commons.standards.home')),
      titleTemplate: '%s | Podosmart',
    };
  },
  async created() {
    this.$pdc.bus!.emitDebug('app:navbar:breadcrumbs', [
      {
        text: this.$t('commons.standards.home'),
        disabled: false,
        to: '/',
      },
    ]);

    await Promise.all([this.setTotalPatient()]);
  },
  mounted() {
    if (!this.showUpdateInformations) this.$pdc.storage!.setUniversal('showUpdateInformations', true);
  },
})
export default class PageHome extends MixinPage {
  totalPatient = null;

  get showUpdateInformations(): boolean {
    return this.$pdc.storage!.getUniversal('showUpdateInformations');
  }

  get doctor() {
    return this.$pdc.doctor?.current;
  }

  get getStartedCompleted() {
    return this.doctor?.getStarted?.completed;
  }

  async setTotalPatient() {
    const result = await this.$pdc.doctor!.getTotalPatientsWithoutDemo();
    this.totalPatient = result.total;
  }

  startAcquisition() {
    (this.$refs.start as any)._open();
  }
}
